<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="stylus">
* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin 0
  padding 0
}
ul li {
  list-style none
}

#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue